import { useState } from 'react';

function LanguagesAdd({ onCreate, submitting }) {
  const [form, setForm] = useState({ iso: '', name: '' });

  async function handleSubmit(event) {
    event.preventDefault();
    await onCreate({
      iso: form.iso.trim().toLowerCase(),
      name: form.name.trim()
    });
    setForm({ iso: '', name: '' });
  }

  return (
    <div className="language-form-shell">
      <div className="language-form-intro">
        <p className="language-form-kicker">Create Language</p>
        <h3>Add a new language</h3>
        <p>
          Set the ISO code and the visible name that will be used across the
          CMS.
        </p>
      </div>

      <form className="language-form-grid" onSubmit={handleSubmit}>
        <label className="language-form-field">
          ISO
          <small>Use a short identifier like `en`, `es`, or `pt-br`.</small>
          <input
            className="field-input"
            maxLength={10}
            value={form.iso}
            onChange={(e) => setForm((prev) => ({ ...prev, iso: e.target.value }))}
            required
          />
        </label>
        <label className="language-form-field">
          Name
          <small>Choose the label users and editors will recognize.</small>
          <input
            className="field-input"
            maxLength={120}
            value={form.name}
            onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
            required
          />
        </label>
        <div className="language-form-actions">
          <button className="button-primary" type="submit" disabled={submitting}>
            {submitting ? 'Saving...' : 'Create language'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default LanguagesAdd;
